import ReonboardingContractModal from './ReonboardingContractModal';

export default ReonboardingContractModal;
